import React from 'react'
import './portfolio.css'
import Img1 from '../../assets/portfolio1.png'
import Img2 from '../../assets/portfolio2.png'
import Img3 from '../../assets/portfolio3.png'
import Img4 from '../../assets/portfolio4.png'
import Img5 from '../../assets/portfolio5.png'
import Img6 from '../../assets/portfolio6.png'



const data = [
  {
    id:1,
    img:Img1,
    title:'Potent, Cryptocurrency Website & Exchange IEO Landing-Borrowing',
    github:'https://github.com/noorshanu',
    demo:'https://potent.finance/'
  },
  {
    id:2,
    img:Img2,
    title:'LA VIDA- IEO, Cryptocurrency Website & Exchange IEO ',
    github:'https://github.com/noorshanu',
    demo:'https://vida.testfarm.live/'
  },
  {
    id:3,
    img:Img3,
    title:'Upwealth - World&#x27;s First Crypto Wealth Building Platform',
    github:'https://github.com/noorshanu',
    demo:'https://www.upwealth.finance/'
  },
  {
    id:4,
    img:Img4,
    title:'VNT Vention | NFT Marketplace',
    github:'https://github.com/noorshanu',
    demo:'https://vention.app/home/'
  },
  {
    id:5,
    img:Img5,
    title:'Tour Terminus |FLight Booking & Booking System',
    github:'https://github.com/noorshanu',
    demo:'https://tourterminus.com/'
  },
  {
    id:6,
    img:Img6,
    title:'Block Audit| Audit, KYC documents, Escrow And Due Diligence,',
    github:'https://github.com/noorshanu',
    demo:'https://blockaudit.report/'
  }
]

function Portfolio() {



  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
      {
        data.map(({id,img,title,github,demo}) =>{
          return(
            <article className="portfolio_item" key={id} >
            <div className="portfolio_item-img">
              <img src={img} alt={title} />
            </div>
            <h3>{title}</h3>
            <div className='portfolio_item-cta'>
            <a href={github} className='btn' target='_blank' rel='noreferrer'>Github</a>
            <a href={demo} className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
            
          </article>
          )
        }
        )
      }
        

        
      </div>
    </section>
  )
}

export default Portfolio